import { createContext, useContext } from "react";

import type { HubTableViewModel } from "./types-hub-table";

export const HubTableContext = createContext<HubTableViewModel | null>(null);

export function useHubTableContext(): HubTableViewModel {
  const context = useContext(HubTableContext);
  if (!context) throw new Error("HubTable.* deve ser usado dentro de HubTable.Root");
  return context;
}
